import { FileReference } from '@kaizenplatform/belfast-entity';
import { FileIdsValue, SelectMultipleValue } from '@kaizenplatform/hugot-entity';
import { ClassAttributes, createElement } from 'react';

import {
  DynamicSchemaDefinitionField,
  DynamicSchemaDefinitionFixed,
  DynamicSchemaDefinitionSelectMultiple,
  DynamicSchemaDefinitionSelectOne,
  DynamicSchemaDefinitionToggle,
} from '../../../../../generated/graphql';
import isIncompleteCreativeBriefField from '../../../../../utility/isIncompleteCreativeBriefField';
import AsEmpty from './AsEmpty';
import AsFiles from './AsFiles';
import AsMultipleSelection from './AsMultipleSelection';
import AsPlainText from './AsPlainText';
import AsSelection from './AsSelection';
import AsToggle from './AsToggle';

interface Props {
  field: DynamicSchemaDefinitionField;
  value: string | number | boolean | SelectMultipleValue | FileIdsValue | null;
  files?: FileReference[];
  className?: string;
}

const Field = ({ field, value, files, className }: ClassAttributes<HTMLElement> & Props) => {
  // we can promise that any values is passed with the corresponding type
  // see CreativeBrief.fromDefinition()

  if (isIncompleteCreativeBriefField(field, value, files)) {
    return <AsEmpty field={field} className={className} />;
  }

  if (field.type === 'SINGLE_LINE_TEXT' || field.type === 'MULTI_LINE_TEXT' || field.type === 'POSITIVE_INTEGER') {
    return <AsPlainText field={field} value={value as any} className={className} />;
  }

  if (field.type === 'FIXED') {
    const _field = field as DynamicSchemaDefinitionFixed;
    return <AsPlainText field={_field} value={_field.value} className={className} />;
  }

  if (field.type === 'SELECT_ONE') {
    return <AsSelection field={field as DynamicSchemaDefinitionSelectOne} value={value as any} className={className} />;
  }

  if (field.type === 'SELECT_MULTIPLE') {
    return (
      <AsMultipleSelection
        field={field as DynamicSchemaDefinitionSelectMultiple}
        value={value as any}
        className={className}
      />
    );
  }

  if (field.type === 'TOGGLE') {
    return <AsToggle field={field as DynamicSchemaDefinitionToggle} value={value as any} className={className} />;
  }

  if (field.type === 'FILES') {
    return <AsFiles field={field} bucketId={value as string} files={files!} className={className} />;
  }

  return null;
};

export default Field;
